export default {"src":"/_next/static/media/monitor-access-changes.b293a8a1.svg","height":664,"width":830,"blurWidth":0,"blurHeight":0};